import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {StockTakeSessionEventModel} from '../../../../../../models/aggregates/erp/stock';
import {Core2Config} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class StocktakeEventService extends BaseApiTemplateService<StockTakeSessionEventModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-event';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-event';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'stocktake-event';
    this.httpClient = http;
  }

}
